import React from 'react'
import Footer from '../components/Footer'

const FooterLayout = () => {
	return (
		<Footer />
	)
}

export default FooterLayout;